import { useEffect, useState } from "react";
import { daysOfWeek, processLessons } from "../../helpers/teacherSchedule/teacherSchedule";
import ScheduleGrid from "../ScheduleGrid/ScheduleGrid";
import axios from "../../axios";
import Modal from "../Modal/Modal";
import { getWeekStartDate } from "../../helpers/weekUtils";
import WeekSelector from "../WeekSelector/WeekSelector";


const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
function RescheduleTeacherBlock({setReschedules, currentWeek, setCurrentWeek, teacher, reschedules, handleCloseModal, joinedLesson, isAdmin, setRescheduleSubmited, selectedLesson, setSelectedLesson, rescheduleModal, setRescheduleModal, setSlotSubmited}){
   const [selectedDayTime, setSelectedDayTime] = useState({});
   const [selectedCell, setSelectedCell] = useState(null);
   const [selectedStudent, setSelectedStudent] = useState(null);
   const [allStudents, setAllStudents] = useState(null)
   const [loading, setLoading] = useState(false)
   
   const [weeks, setWeeks] = useState([]);

   useEffect(() => {
      axios.get('students/all').then(data => setAllStudents(data.data))
   },[])
   
   useEffect(() => {
    const generateWeeks = () => {
      const weeksList = [];
      const today = new Date();
      
      for (let i = 0; i < 5; i++) {
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() + (i * 7));
        weeksList.push(getWeekStartDate(weekStart));
      }
      
      setWeeks(weeksList);
    };
    
    generateWeeks();
  }, []);

  
  const allLessons = [
    ...processLessons(teacher.students || [], "Regular", teacher.googleMeetLink, currentWeek),
    ...processLessons(teacher.trialLessons || [], "Trial", teacher.googleMeetLink, currentWeek),
    ...processLessons(reschedules || [], "Reschedule", teacher.googleMeetLink, currentWeek),
  ];
   const handleLessonClick = (lesson) => {
   
      setSelectedLesson(lesson);
      
   };
  const resheduleLesson = (day, hour, minute = 0) => {
    setRescheduleModal(true);

    // Переклад індексу дня у назву
    const dayName = days[day];

    // Формуємо рядок часу з урахуванням хвилин
    const hh = hour.toString().padStart(2, "0");
    const mm = minute.toString().padStart(2, "0");
    const timeString = `${hh}:${mm}`;

    setSelectedDayTime({ day: dayName, time: timeString });
  };
   const submitReschedule = () => {
    setLoading(true);
    console.log(selectedDayTime)
    axios.post(`lesson-reschedule/${selectedStudent}/${teacher._id}`, { 
      lessonReschedule: selectedDayTime,
      weekStartDate: currentWeek 
    })
    .then(() => {
      setSelectedStudent('');
      setSelectedCell(null);
      setSelectedDayTime({ day: "", time: "" });
      setRescheduleSubmited(true);
      setRescheduleModal(false);
      if(!isAdmin){
        axios.post(`teacher/rescheduled/${teacher._id}/${selectedStudent}/reschedule`, { 
          lessonReschedule: selectedDayTime,
          weekStartDate: currentWeek 
        });
      }
    })
    .catch(() => console.log('Щось пішло не так'))
    .finally(() => setLoading(false));
  };
  const cancelLesson = (id) => {
    setLoading(true);
    const dayName = days[selectedLesson.day];

    if(selectedLesson.type === 'Reschedule Lesson' || selectedLesson.type === 'Substitute'){
       axios.delete(`lesson-reschedule/${selectedLesson._id}`)
       .then(res => {
          setReschedules(prev =>
          prev.filter(item => item._id !== selectedLesson._id)
        );
         setSelectedLesson(null);
      })
       .catch(err => console.error(err))
       // loading спільний для модалки: без скидання наступна модалка (перенесення на вільний слот) вічно «вантажилась»
       .finally(() => setLoading(false));
    }else{
      const student = (allStudents || []).find((res) => res.studentId === id);
      if (!student) {
        console.error('Учня не знайдено — урок не скасовано');
        setLoading(false);
        return;
      }
      const studentId = student._id;
      const weekStart = new Date(currentWeek);
      weekStart.setUTCHours(0, 0, 0, 0);
      
      axios.post(`lesson-reschedule/cancel/${studentId}/${teacher._id}`, {
        lessonReschedule: {
          day: dayName,
          time: selectedLesson.time,
          date: weekStart.toISOString(), // Используем нормализованную дату
        },
        weekStartDate: weekStart.toISOString()
      })
      .then(() => {
        return axios.get(`lesson-reschedule/${teacher._id}?weekStartDate=${weekStart.toISOString()}`);
      })
      .then(res => {
        setReschedules(res.data.lesson);
        setSelectedLesson(null);
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
    }
    
  };
  

  const sumbitSlot = (type) => {
    setLoading(true)
    const fullSlot = { ...selectedDayTime, type: type };
    axios.post(`teacher/open-slot/${teacher._id}`, { slot: fullSlot })
      .then(() => {
        setSelectedDayTime({ day: "", time: "" })
        setRescheduleModal(false)
        setSlotSubmited(true)
        
      })
      .catch(() => console.log('Щось пішло не так'))
      .finally(() => setLoading(false))
  };

  const onDeleteSlot = (slot) => {
    setLoading(true)
    const notFullSlot = { day: slot.day, time: slot.time };
    
    axios.post(`teacher/close-slot/${teacher._id}`, { slot: notFullSlot })
      .then(() => {
        setSlotSubmited(true)
      })
      .catch(() => console.log('Щось пішло не так'))
      .finally(() => setLoading(false))
  }
     
  return (
    <>
      <WeekSelector 
        weeks={weeks} 
        currentWeek={currentWeek} 
        setCurrentWeek={setCurrentWeek} 
      />
      <ScheduleGrid
        daysOfWeek={daysOfWeek}
        lessons={allLessons}
        handleLessonClick={handleLessonClick}
        resheduleLesson={resheduleLesson}
        selectedCell={selectedCell} 
        setSelectedCell={setSelectedCell} 
        isReschedule={rescheduleModal}
        setSelectedLesson={setSelectedLesson}
        teacher={teacher}
        onDeleteSlot={onDeleteSlot}
        currentWeek={currentWeek}
      />
      {(rescheduleModal || selectedLesson) && (
        <Modal
          lesson={selectedLesson}
          onClose={handleCloseModal}
          joinedLesson={joinedLesson}
          isReschedule={rescheduleModal}
          students={teacher.students}
          setSelectedStudent={setSelectedStudent}
          submitReschedule={submitReschedule}
          selectedStudent={selectedStudent}
          setSelectedCell={setSelectedCell} 
          loading={loading}
          cancelLesson={cancelLesson}
          sumbitSlot={sumbitSlot}
          isAdmin={isAdmin}
        />
      )}
    </>
  )
};

export default RescheduleTeacherBlock;